import { Component, OnInit } from '@angular/core';
import { IMAGES } from 'src/app/constants/imagePath';

@Component({
    selector: 'app-cariq-score',
    templateUrl: './cariq-score.component.html',
    styleUrls: ['./cariq-score.component.scss'],
    standalone: false
})
export class CariqScoreComponent implements OnInit {
  Images = IMAGES;
  constructor() { }

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'auto' });

  }

}
